
<ng-container *ngIf="isLoading; else pageContent">
	<div class="app-spinner">
		<mat-spinner></mat-spinner>
	</div>
</ng-container>

<ng-template #pageContent>
<div class="resource-container position-relative">
	<div class="d-flex pt-3 ms-1">
		<span class="create-account">Quizzes</span>
		<span class="count-badge ms-3 mt-1">{{quizResources.length}}</span>
	</div>

	<ng-container *ngIf="quizResources.length > 0 else noQuizFound">
  <div class="main-card mt-3 rounded-4">
    <div class="resource-grid">
      <div class="quiz-card" *ngFor="let quiz of quizResources">
        <div class="quiz-header">
          <div class="quiz-icon">
            <img src="assets/images/unknown_document.svg" alt="quiz-icon"/>
          </div>
          <h5 class="quiz-title">{{ quiz.title }}</h5>
        </div>
        <div class="quiz-details">
          <div class="quiz-info">
            <div class="quiz-meta">
              <img src="assets/images/calendar_today.svg" width="16" height="16" class="me-1" />
              <span>{{ quiz.date }}</span>
            </div>
            <div *ngIf="quiz.status === 'pending'" class="quiz-questions">
              Questions: <span>{{ quiz.questions }}</span>
            </div>
            <div *ngIf="quiz.status !== 'pending'" class="quiz-score">
              Score: <span>{{ quiz.score }}</span>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <button *ngIf="quiz.status === QuizStatus.PENDING" class="take-btn" (click)="openTakeQuizPopup(quiz)">
          <img src="assets/images/play_arrow_1.svg" alt="play-icon" class="quiz-icon2" />
          Take Quiz
        </button>
        <button *ngIf="quiz.status === QuizStatus.SUBMITTED || quiz.status === QuizStatus.AUTO_SUBMITTED" class="view-btn" (click)="viewQuizResult(quiz)">
          <img src="assets/images/task_alt.svg" alt="check-icon" class="view-icon" />
          View Result
        </button>
		 <button *ngIf="quiz.status === QuizStatus.IN_PROGRESS" class="view-btn" (click)="goToQuizDetailPage(quiz.quizId , quiz.attemptId)">
          <img src="assets/images/task_alt.svg" alt="check-icon" class="view-icon" />
          Resume Quiz
        </button>
      </div>
    </div>
  </div>
  </ng-container>
  <ng-template #noQuizFound>
	<p class="text-center mt-4"> No Quizzes found</p>
  </ng-template>
</div>
</ng-template>